import { useEffect } from "react";
import { useLocation } from "react-router-dom";

type AppTitleProps = {
  title: string;
  suffix: string;
};

const AppTitle = ({ title, suffix = "GuruNow" }: AppTitleProps) => {
  const location = useLocation();

  useEffect(() => {
    document.title = `${title}${suffix ? ` - ${suffix}` : ""}`;
  }, [location, title]);

  return null;
};

export default AppTitle;
